import { render, staticRenderFns } from "./TreeNodeEdit.vue?vue&type=template&id=b4d86b2c"
import script from "./TreeNodeEdit.vue?vue&type=script&lang=js"
export * from "./TreeNodeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports